import styled from "styled-components";

export const Wrapper = styled.div``;

export const Table = styled.table`
  width: 100%;
  max-width: 540px;
`;

export const Header = styled.thead`
  font-family: "Rubik";
  font-size: 18px;
  font-weight: 600;
  color: #141823;
`;

export const HeaderColumn = styled.th`
  background-color: #d1e5ff;
  width: 50%;
  padding: 16px;

  &:first-child {
    border-top-left-radius: 12px;
  }

  &:last-child {
    border-top-right-radius: 12px;
  }
`;

export const Title = styled.h2`
  padding-top: 0rem;
  margin-bottom: 2rem;
  font-family: "Rubik";
  font-size: 18px;
  font-weight: 600;
`;

export const BodyWrapper = styled.tbody`
  padding: 0 18px 0 24px;
  background-color: #fff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

export const TableRow = styled.tr`
  width: 100%;
  border-bottom: 1px solid #eaeaea;

  &:last-child {
    border-bottom: 0;
  }
`;

export const TitleColumn = styled.td`
  font-family: "Rubik";
  font-size: 16px;
  font-weight: 600;
  width: 50%;
  padding: 16px;
`;

export const ValueColumn = styled.td`
  font-family: "Rubik";
  font-size: 16px;
  font-weight: 400;
  width: 50%;
  padding: 16px;
`;
